import React from "react";
import noDataIcon from "../../assets/images/noData.svg";
import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";

interface NoDataProps {
  searchInput: string;
}

const NoDataScreen: React.FC<NoDataProps> = ({ searchInput }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <img src={noDataIcon} alt="No data found" />
      {searchInput ? (
        <>
          {" "}
          <p className={styles.noDataSearchText}>
            {t("pa.noDataForSearch")} <strong>{searchInput}</strong>.
          </p>
          <p className={styles.noDataForSearchDescription}>
            {t("pa.noDataForSearchDescription")}
          </p>
        </>
      ) : (
        <p className={styles.noDataSearchText}>{t("pa.noClientsFound")}</p>
      )}
    </div>
  );
};

export default NoDataScreen;
